export default __webpack_public_path__ + "static/media/itchbook-grey.bb0a96d0.svg";